import HandleAutoSave from './HandleAutoSave';

export default HandleAutoSave;